<template>

  <v-container fluid class="px-0 order-info-supporting-docs">

    <!-- Order Supporting Docs -->
    <order-supporting-documents class="page-content" :order="order" />

  </v-container>

</template>

<script>
import OrderSupportingDocuments from '@/components/orders/OrderSupportingDocuments'

export default {
  name: 'OrderInfoSupportingDocuments',

  components: {
    OrderSupportingDocuments
  },

  props: {
    orderId: {
      type: String,
      default: null
    }
  },

  computed: {
    order () {
      return this.$parent.order
    }
  },

  methods: {
    async reloadOrderData () {
      return this.$parent.reloadOrderData()
    }
  }
}
</script>

<style>
</style>
